import { render } from "./NameStep.vue?vue&type=template&id=35a4315a&scoped=true"
import script from "./NameStep.vue?vue&type=script&lang=js"
export * from "./NameStep.vue?vue&type=script&lang=js"

import "./NameStep.vue?vue&type=style&index=0&id=35a4315a&scoped=true&lang=css"
import "./NameStep.vue?vue&type=style&index=1&id=35a4315a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a4315a"]])

export default __exports__